import React from 'react';
import PropTypes from "prop-types";
import { Modal, Button } from 'rhombus-react';

import { noop } from 'utils/common';
import ConflictsTable from "./ConflictsTable";

const videoDisclaimer = "Please Note: You may need to re-encode some assets if any creatives use manually encoded variants.";

export default function OverwriteMultipleModal(props) {
	const {
		assetType,
		conflicts,

		onConfirmOverwrite,
		onBack,
	} = props;

	function renderContent(){
		return (
			<div className="table-container">
				<p className="error-msg">
					The following assets already exist in the creative library and will be overwriten.
					The “Creative Usage” column displays the number of creatives where the assets are currently in use. <br />
					{(assetType === "videos") && videoDisclaimer}
				</p>
				<ConflictsTable conflicts={conflicts} />
			</div>
		);
	}

	function renderFooter(){
		return (
			<>
				<Button onClick={onBack} theme="default">Back</Button>
				<Button theme="red" onClick={() => onConfirmOverwrite()}>Confirm Overwrite</Button>
			</>
		);
	}

	let modalProps = {
		type: "modal",
		title: "Confirm Overwriting Assets",
		allowFullScreen: false,
		className: "upload-error-modal",
		xClose: false,
		bladeProps: {
			verticallyCenter: true,
		},
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

OverwriteMultipleModal.displayName = "OverwriteMultipleModal";

OverwriteMultipleModal.propTypes = {
	assetType: PropTypes.oneOf([
		"images",
		"richloads",
		"videos",
		// "audios",
	]),
	conflicts: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		creatives: PropTypes.array,
	})),

	onConfirmOverwrite: PropTypes.func,
	onBack: PropTypes.func,
};

OverwriteMultipleModal.defaultProps = {
	conflicts: [],

	onConfirmOverwrite: noop,
	onBack: noop,
};
